import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstFieldService {
  mstGender: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mst_field/list/?';
  private DeListRecord = webapi + 'mst_field/deactivated_list/?';
  private AddRecord = webapi + 'mst_field/create';
  private EditRecord = webapi + 'mst_field/update';
  private GetRecord = webapi + 'mst_field/byid/';
  private GetRecordToConcatinate = webapi + 'mst_field/byidToConcat/';
  private DeleteRecord = webapi + 'mst_field/delete/';
  private ReActiveRecord = webapi + 'mst_field/reActive/';
    private ListRecordBySetId = webapi + 'mst_field/getfieldlistbysetid/';
    private ListRecordByDsfId = webapi + 'mst_field/getfieldlistbydsfid/';
    private ListByDsfIdSectionIdTabIdSetId = webapi + 'mst_dsf_field/getfieldlistbydsfidsectionidtabidsetid/';
    private AddRecordAnswer = webapi + 'mst_question_answer/create';
    private QuationAnswerListByFieldId= webapi + 'mst_question_answer/getaqlistbyfieldid/';
    private QuationAnswerByAnswerNameFieldId= webapi + 'mst_question_answer/getbyanswernamefieldid/';

    constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    addRecordAnswerService(model: any) {
        return this.http.post(this.AddRecordAnswer, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getConcatenate(id: any) {
    return this.http.post(this.GetRecordToConcatinate , JSON.stringify(id), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }


    getQAListRecordService(id: any) {
        return this.http.get(this.QuationAnswerListByFieldId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getQARecordByAnswerNameFieldId(answerName: any, fieldId: any) {
        return this.http.get(this.QuationAnswerByAnswerNameFieldId + answerName + '/' + fieldId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordServiceBySetId(id: any) {
        return this.http.get(this.ListRecordBySetId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

 getRecordServiceByDsfId(id: any) {
        return this.http.get(this.ListRecordByDsfId + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getFieldListByDsfIdSectionIdTabIdSetId(dsfId: any, sectionId: any, tabId: any, setId: any) {
        return this.http.get(this.ListByDsfIdSectionIdTabIdSetId + dsfId + '/' + sectionId + '/' + tabId + '/' + setId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-field/mst-field.service.ts